/* 1b — the six cards in the scroller under the mobile Watercraft banner.
   Ported from `01-placements/1b_homepage-banner-mobile-expanded.html`. They
   are returned as a fragment so they are direct children of the scroll-snap
   row in WatercraftBannerMobile, which is what the dot indicator measures
   against. The pack is explicit that this row stays a scroller and must not
   become a grid or a stack.

   Colours are remapped onto the app palette in `tokens.js` and written as
   literals, as in WatercraftCardWall — the markup is generated. */
import React from 'react';
import watersMap from '../../assets/images/watercraft/waters_map.jpg';
import { ReactComponent as Wordmark } from '../../assets/images/watercraft/wc_wordmark.svg';

export const WATERCRAFT_CARD_COUNT = 6;

export default function WatercraftCards() {
  return (
    <>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#162419',
          border: '1px solid #2A4030',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
        }}
      >
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '18px',
            fontWeight: '700',
            color: '#EEF4EB',
            letterSpacing: '-.015em',
            marginBottom: '6px',
          }}
        >
          Sessions
        </div>
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '12.5px',
            lineHeight: '1.5',
            color: '#9AB49B',
            fontWeight: '300',
          }}
        >
          Swims, notes and conditions kept together as it happens, not written
          up from memory.
        </div>
        <div
          style={{
            marginTop: '13px',
            border: '1px solid #2A4030',
            borderRadius: '10px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              background: '#1A5C2A',
              padding: '7px 11px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: '9px',
                letterSpacing: '.14em',
                textTransform: 'uppercase',
                color: '#EEF4EB',
                fontWeight: '600',
                whiteSpace: 'nowrap',
              }}
            >
              In session · Swim 4
            </span>
            <span
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: '10px',
                color: '#EEF4EB',
              }}
            >
              14:22
            </span>
          </div>
          <div style={{ padding: '11px' }}>
            <div
              style={{
                height: '6px',
                borderRadius: '6px',
                background: '#1E3024',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: '43%',
                  height: '6px',
                  borderRadius: '6px',
                  background: '#3DFF6A',
                }}
              ></div>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: '12px',
            paddingTop: '11px',
            borderTop: '1px solid #2A4030',
            fontFamily: "'JetBrains Mono',monospace",
            fontSize: '9px',
            letterSpacing: '.1em',
            textTransform: 'uppercase',
            color: '#6E8270',
          }}
        >
          157 hours on the bank
        </div>
      </div>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#162419',
          border: '1px solid #2A4030',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
        }}
      >
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '18px',
            fontWeight: '700',
            color: '#EEF4EB',
            letterSpacing: '-.015em',
            marginBottom: '6px',
          }}
        >
          Catch reports
        </div>
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '12.5px',
            lineHeight: '1.5',
            color: '#9AB49B',
            fontWeight: '300',
          }}
        >
          Weight, bait and swim in seconds. The conditions are captured for you.
        </div>
        <div
          style={{
            marginTop: '13px',
            background: '#1E3024',
            border: '1px solid #2A4030',
            borderRadius: '10px',
            padding: '12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '9px',
            }}
          >
            <span
              style={{
                flex: '1',
                fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
                fontSize: '13px',
                fontWeight: '600',
                color: '#EEF4EB',
              }}
            >
              Mirror carp
            </span>
            <span
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: '9px',
                color: '#3DFF6A',
                border: '1px solid #3DFF6A',
                borderRadius: '100px',
                padding: '3px 8px',
                whiteSpace: 'nowrap',
              }}
            >
              PB
            </span>
            <span
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: '14px',
                color: '#3DFF6A',
              }}
            >
              27:04
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontFamily: "'JetBrains Mono',monospace",
              fontSize: '9px',
              color: '#6E8270',
            }}
          >
            <span>KRILL 20MM</span>
            <span>↓ 1012 hPa</span>
          </div>
        </div>
      </div>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#162419',
          border: '1px solid #2A4030',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
        }}
      >
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '18px',
            fontWeight: '700',
            color: '#EEF4EB',
            letterSpacing: '-.015em',
            marginBottom: '6px',
          }}
        >
          Patterns
        </div>
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '12.5px',
            lineHeight: '1.5',
            color: '#9AB49B',
            fontWeight: '300',
          }}
        >
          Your own catch history read back to you. Not a prediction.
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '2px',
            height: '42px',
            margin: '14px 0 6px',
          }}
        >
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '44px',
              background: '#3DFF6A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '17px',
              background: '#1A5C2A',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
          <span
            style={{
              flex: '1',
              height: '3px',
              background: '#1E3024',
              borderRadius: '2px',
              display: 'block',
            }}
          ></span>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontFamily: "'JetBrains Mono',monospace",
            fontSize: '9px',
            color: '#6E8270',
          }}
        >
          <span>00</span>
          <span>06</span>
          <span>12</span>
          <span>18</span>
          <span>24</span>
        </div>
        <div
          style={{
            marginTop: '12px',
            paddingTop: '11px',
            borderTop: '1px solid #2A4030',
            fontFamily: "'JetBrains Mono',monospace",
            fontSize: '9px',
            letterSpacing: '.1em',
            textTransform: 'uppercase',
            color: '#6E8270',
          }}
        >
          45% of takes · 07:00–10:00
        </div>
      </div>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#162419',
          border: '1px solid #2A4030',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
        }}
      >
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '18px',
            fontWeight: '700',
            color: '#EEF4EB',
            letterSpacing: '-.015em',
            marginBottom: '6px',
          }}
        >
          Waters
        </div>
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '12.5px',
            lineHeight: '1.5',
            color: '#9AB49B',
            fontWeight: '300',
          }}
        >
          Real satellite views of every water, with your swims and marks on top.
        </div>
        <div
          style={{
            marginTop: '13px',
            height: '104px',
            borderRadius: '10px',
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid #2A4030',
            background: '#0C1A0F',
          }}
        >
          <img
            src={watersMap}
            alt=''
            data-image-slot='wc-waters-map'
            style={{
              position: 'absolute',
              inset: '0',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      </div>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#162419',
          border: '1px solid #2A4030',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
        }}
      >
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '18px',
            fontWeight: '700',
            color: '#EEF4EB',
            letterSpacing: '-.015em',
            marginBottom: '6px',
          }}
        >
          Conditions
        </div>
        <div
          style={{
            fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
            fontSize: '12.5px',
            lineHeight: '1.5',
            color: '#9AB49B',
            fontWeight: '300',
          }}
        >
          Air, pressure, wind and the solunar windows for the day ahead.
        </div>
        <div
          style={{
            display: 'flex',
            gap: '12px',
            marginTop: '13px',
            alignItems: 'center',
          }}
        >
          <div style={{ flex: 'none' }}>
            <div
              style={{
                fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
                fontSize: '19px',
                fontWeight: '700',
                color: '#EEF4EB',
                lineHeight: '1',
              }}
            >
              1011<span style={{ fontSize: '11px', color: '#3B9EBF' }}>↓</span>
            </div>
            <div
              style={{
                fontFamily: "'JetBrains Mono',monospace",
                fontSize: '9px',
                letterSpacing: '.1em',
                color: '#6E8270',
                marginTop: '5px',
              }}
            >
              PRESSURE
            </div>
          </div>
          <svg
            viewBox='0 0 160 46'
            style={{ flex: '1', display: 'block', height: '46px' }}
          >
            <path
              d='M2 40 C 12 40, 16 14, 26 14 C 36 14, 40 38, 52 38 C 70 38, 76 30, 86 26 C 96 22, 102 30, 112 36 C 122 40, 128 12, 140 12 C 152 12, 156 34, 158 38'
              fill='none'
              stroke='#3DFF6A'
              strokeWidth='2.2'
              strokeLinecap='round'
            />
            <line
              x1='112'
              y1='2'
              x2='112'
              y2='42'
              stroke='#F5A623'
              strokeWidth='1.3'
              strokeDasharray='3 3'
            />
          </svg>
        </div>
        <div
          style={{
            marginTop: '12px',
            paddingTop: '11px',
            borderTop: '1px solid #2A4030',
            fontFamily: "'JetBrains Mono',monospace",
            fontSize: '9px',
            letterSpacing: '.1em',
            textTransform: 'uppercase',
            color: '#6E8270',
          }}
        >
          Major 05:14 · 17:39
        </div>
      </div>
      <div
        style={{
          flex: 'none',
          width: '300px',
          boxSizing: 'border-box',
          scrollSnapAlign: 'center',
          background: '#1E3024',
          border: '1px solid #2E8C47',
          borderRadius: '14px',
          padding: '16px',
          boxShadow: '0 18px 36px rgba(0,0,0,.5)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <Wordmark
            role='img'
            aria-label='Watercraft'
            style={{
              width: '60px',
              height: '38px',
              display: 'block',
              marginBottom: '14px',
              color: '#EEF4EB',
            }}
          />
          <div
            style={{
              fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
              fontSize: '18px',
              fontWeight: '700',
              color: '#EEF4EB',
              letterSpacing: '-.015em',
              lineHeight: '1.25',
            }}
          >
            Plus loads more…
          </div>
          <div
            style={{
              fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
              fontSize: '12.5px',
              lineHeight: '1.5',
              color: '#9AB49B',
              fontWeight: '300',
              marginTop: '6px',
            }}
          >
            Download and use for{' '}
            <span style={{ color: '#3DFF6A', fontWeight: '600' }}>FREE</span>{' '}
            now.
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '18px',
            marginTop: '14px',
            paddingTop: '13px',
            borderTop: '1px solid #2E8C47',
          }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            <svg
              viewBox='0 0 24 24'
              style={{ width: '13px', height: '16px', display: 'block' }}
              fill='#EEF4EB'
              aria-hidden='true'
            >
              <path d='M17.05 12.53c-.02-2.2 1.79-3.26 1.87-3.31-1.02-1.49-2.61-1.7-3.17-1.72-1.35-.14-2.63.79-3.31.79-.68 0-1.79-.77-2.94-.75-1.51.02-2.9.88-3.68 2.23-1.57 2.72-.4 6.74 1.13 8.95.75 1.08 1.64 2.24 2.81 2.2 1.13-.04 1.56-.73 2.93-.73 1.36 0 1.75.73 2.94.71 1.21-.02 1.98-1.1 2.72-2.19.85-1.25 1.2-2.46 1.22-2.52-.03-.01-2.34-.9-2.36-3.56z' />
              <path d='M14.9 6.02c.6-.72 1-1.72.89-2.72-.86.03-1.9.57-2.52 1.29-.55.63-1.03 1.65-.9 2.62.96.07 1.93-.49 2.53-1.19z' />
            </svg>
            <span
              style={{
                fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
                fontSize: '12px',
                fontWeight: '500',
                color: '#EEF4EB',
              }}
            >
              App Store
            </span>
          </span>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            <svg
              viewBox='0 0 24 24'
              style={{ width: '13px', height: '16px', display: 'block' }}
              aria-hidden='true'
            >
              <path
                d='M4 2.4 L18.6 12 L4 21.6 Z'
                fill='none'
                stroke='#EEF4EB'
                strokeWidth='1.8'
                strokeLinejoin='round'
              />
            </svg>
            <span
              style={{
                fontFamily: "'Libre Franklin',Helvetica,Arial,sans-serif",
                fontSize: '12px',
                fontWeight: '500',
                color: '#EEF4EB',
              }}
            >
              Google Play
            </span>
          </span>
        </div>
      </div>
    </>
  );
}
